import { EntitiesState } from '@redux/entities'

export const statusKeys = [
  'approved',
  'awaiting_qc',
  'awaiting_review',
  'booked',
  'complete',
  'declined',
  'delivered',
  'dispatched',
  'held',
  'installed',
  'packaged',
  'pending',
  'printed',
  'processed',
  'processing',
  'queued',
  'rejected',
  'released',
  'removed',
  'sent',
  'urgent',
] as const

export const pendingStatusKeys = [
  'awaiting_review',
  'booked',
  'pending',
] as const

export const statusColors = {
  approved: 'green',
  awaiting_review: 'orange',
  awaiting_qc: 'orange',
  booked: 'tan',
  cancelled: 'darkGrey',
  complete: 'green',
  declined: 'red',
  delivered: 'green',
  dispatched: 'green',
  held: 'tan',
  installed: 'green',
  pending: 'orange',
  printed: 'tan',
  processed: 'tan',
  processing: 'purple',
  released: 'tan',
  rejected: 'red',
  removed: 'red',
  urgent: 'red',
}

export const findStatusByKey = (statuses: EntitiesState['statuses'], defaultStatusKey: string) => {
  if (!defaultStatusKey) return {}
  return Object.values(statuses).find(status => status.key === defaultStatusKey) || {}
}
